module.exports = __webpack_public_path__ + "img/img-intro-app-1-jp.ee98d6d0.svg";